<template>
	<v-dialog
		v-model="visible"
		:max-width="image_width <= 500 ? 500 : image_width"
		persistent
		hide-overlay
	>
		<div class="image-show" v-if="image.length === 1">
			<div :style="{width:image_width+'px', height: image_height+'px' , transform:'scale('+multiples+')',transformOrigin:'center'}">
				<img
					v-drag
					:class="`image-show-box ${deg !== 0 || multiples !== 1 ? 'image-show-drag': ''} `"
					:src="image[0]" 
					:width="image_width" 
					:height="image_height" 
					alt="receipt" 
					:style="{transform:'rotateZ('+deg+'deg)'}"/>
			</div>
			<div class="image-show-btn">
				<v-btn icon depressed color="info" class="white--text" @click.stop="zoomIn()">
					<v-icon>mdi-magnify-plus</v-icon>
				</v-btn>
				<v-btn icon depressed color="info" class="white--text" @click.stop="zoomOut()">
					<v-icon>mdi-magnify-minus</v-icon>
				</v-btn>
				<!-- <v-btn v-if="!$vuetify.breakpoint.smAndUp" :height="20" depressed color="info" class="white--text text-capitalize ml-2" @click.stop="openNewTab()">
					<span style="font-size: 12px">open</span>
				</v-btn> -->
				<v-btn rounded small depressed color="#00AAFD" class="white--text" @click.stop="imageClose()">
					CLOSE
				</v-btn>
				<v-btn icon depressed color="info" class="white--text" @click.stop="rotate_left()">
					<v-icon>mdi-rotate-left-variant</v-icon>
				</v-btn>
				<v-btn icon depressed color="info" class="white--text" @click.stop="rotate_right()">
					<v-icon>mdi-rotate-right-variant</v-icon>
				</v-btn>
			</div>
		</div>
		<v-carousel class="image-show" v-if="image.length > 1" v-model="multi_pdf_model" hide-delimiters height="100%">
			<v-carousel-item
				v-for="(image_item, index) in image"
				:key="index"
			>
				<div :style="{width:image_width+'px', height:image_height+'px' , transform:'scale('+multiples+')',transformOrigin:'center'}">
					<img
						v-drag
						:class="`image-show-box ${deg !== 0 || multiples !== 1 ? 'image-show-drag': ''} `"
						:src="image_item" 
						:width="image_width" 
						:height="image_height" 
						alt="receipt" 
						:style="{transform:'rotateZ('+deg+'deg)'}"/>
				</div>
				<div class="image-show-btn">
					<v-btn icon depressed color="info" class="white--text" @click.stop="zoomIn()">
						<v-icon>mdi-magnify-plus</v-icon>
					</v-btn>
					<v-btn icon depressed color="info" class="white--text" @click.stop="zoomOut()">
						<v-icon>mdi-magnify-minus</v-icon>
					</v-btn>
					<!-- <v-btn v-if="!$vuetify.breakpoint.smAndUp" :height="20" depressed color="info" class="white--text text-capitalize ml-2" @click.stop="openNewTab()">
						<span style="font-size: 12px">open</span>
					</v-btn> -->
					<v-btn rounded small depressed color="#00AAFD" class="white--text" @click.stop="imageClose()">
						CLOSE
					</v-btn>
					<v-btn icon depressed color="info" class="white--text" @click.stop="rotate_left()">
						<v-icon>mdi-rotate-left-variant</v-icon>
					</v-btn>
					<v-btn icon depressed color="info" class="white--text" @click.stop="rotate_right()">
						<v-icon>mdi-rotate-right-variant</v-icon>
					</v-btn>
				</div>
			</v-carousel-item>
		</v-carousel>
	</v-dialog>
</template>
<script>

export default {
	name: 'ReceiptImageView',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		show_image: {
			type: Object,
			default: () => {}
		},
	},
	data() {
		return {
			image: this.show_image.image,
			image_height: this.show_image.image_height,
			image_width: this.show_image.image_width,
			deg: 0,
			multiples: 1,
			multi_pdf_model: 0
		}
	},
	directives: {
		drag: function (el) {
			let oDiv = el;   //current element
			oDiv.onmousedown = function (e) {
				e.preventDefault();
				let bw = document.body.clientWidth;
				let bh = document.body.clientHeight;
				//mouse down，calculate the distance from view
				let disX = e.clientX - oDiv.offsetLeft;
				let disY = e.clientY - oDiv.offsetTop;
				// calculate the Coordinate
				document.onmousemove = function (e) {
					let l = 0, t = 0;
					if (e.clientX >= bw) {
						l = bw - disX;
					} else if (e.clientX <= 0) {
						{
							l = 0- disX;
						}
					} else {
						l = e.clientX - disX;
					}
					if (e.clientY >= bh) {
						t = bh - disY;
					}else if(e.clientY <= 0) {
						t = 0- disY;
					}
					else {
						t = e.clientY - disY;
					}
					// move currrent element
					oDiv.style.left = l + 'px';
					oDiv.style.top = t + 'px';
				};

				// mouse stop, clear event
				document.onmouseup = function () {
					document.onmousemove = null;
					document.onmouseup = null;
				};
			};
		}
	},
	methods: {
		zoomIn(){
			if(this.multiples >= 3){
				return
			}
			this.multiples += 0.25
		},
		zoomOut(){
			if(this.multiples <= 0.5){
				return
			}
			this.multiples -= 0.25
		},
		imageClose() {
			this.image = '';
			this.image_height = 0;
			this.image_width = 0;
			this.deg = 0;
			this.multiples = 1;
			this.$emit('image-close');
		},
		rotate_left(){
			this.deg -= 90;
			
			if(this.deg <= -360){
				this.deg = 0
			}
		},
		rotate_right(){
			this.deg += 90;

			if(this.deg >= 360){
				this.deg = 0
			}
		},
		openNewTab() {
			axios
				.get(this.show_image.url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					},
					responseType: 'blob',
				})
				.then((val) => {
					const { status, data } = val;

					if (status === 200) {
						const eleLink = document.createElement('a');
						// eleLink.download = 'JBX';
						eleLink.style.display = 'none';
						eleLink.href = URL.createObjectURL(data);
						document.body.appendChild(eleLink);
						eleLink.click();
						document.body.removeChild(eleLink);
						window.URL.revokeObjectURL(eleLink.href);
					}
				})
				.catch((e) => {
					console.log('error message:', e.message);
				});
		}
	}
}
</script>
<style lang="scss" scoped>
.image-show {
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	background: #FFFFFF;
}
.image-show-box {
	position: absolute;
}
.image-show-drag {
	&:hover {
		cursor: all-scroll;
	}
}
.image-show-btn {
	display: flex;
	flex-flow: row nowrap;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	background: rgba(255, 255, 255, 0.4);
}
.v-icon.v-icon {
  font-size: 20px;
}
::v-deep {
	.v-dialog:not(.v-dialog--fullscreen) {
		max-height: 100%;
	}
}

</style>